import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from '@mui/material';
import BaseTypography from '@mui/material/Typography';
export const Typography = ({ children, loading = false, sx = {}, dangerouslySetInnerHTML, ...rest }) => {
    if (dangerouslySetInnerHTML) {
        if (loading) {
            return _jsx(Skeleton, { variant: "text", height: "100%", width: "100%" });
        }
        return (_jsx(BaseTypography, { ...rest, sx: { width: '100%', ...sx }, dangerouslySetInnerHTML: dangerouslySetInnerHTML }));
    }
    return (_jsx(BaseTypography, { ...rest, sx: { width: '100%', ...sx }, children: loading ? _jsx(Skeleton, { variant: "text", height: "100%", width: "100%" }) : children }));
};
